<template>
    <ButtonComponent class = "changePasswordModal__container__button"
                    label = "Удалить аккаунт"
                    elementType = "default-bg"
                    :elementInLoading="this.requesting"
                    elementStatusModifier="danger"
                    @click_to_button="this.openFilePreview" />
</template>

<script>

import ButtonComponent from '@/units/forms/RichButton.vue';
import ConfirmAccountDeletion from './ConfirmAccountDeletion.vue';

export default {
  components: {
    ButtonComponent,
  },
  data: () => ({
  }),
  methods: {
    openFilePreview() {
      window.openWindow({
        caption: 'Вы действительно хотите удалить свой аккаунт?',
        component: ConfirmAccountDeletion,
        componentProps: {
        //   draw_file: this.HtmlFile,
        //   send_files: this.params.sendFiles,
        //   files_local_downloader: this.params.filesLocalDownloader,
        },
      });
    },
  },
};
</script>

<style lang="less">
.changePasswordModal {
  &__container {
    min-width: 250px;
    width: 15vw;
    display: grid;
    grid-row-gap: 20px;

    &__group {
      display: grid;
      grid-row-gap: 10px;
    }
    &__input {
      width: 100%;
    }
  }

}
</style>
